import { theme } from '@global-engineering-shared/gweb-material-theme-next';
import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(() => ({
  actionButton: {
    justifyContent: 'flex-start',
    color: theme.palette.primary.dark,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.main,
    },
    width: '300px',
  },
  menuItem: {
    padding: 0,
  },
}));

export default useStyles;
